const TIPOS_HSM = [
  {
    id: 0,
    name: 'Gateway sin HSM',
  },
  {
    id: 1,
    name: 'RedTrust',
  },
  {
    id: 2,
    name: 'Ivnosys',
  },
  {
    id: 3,
    name: 'SIA',
  },
  {
    id: 4,
    name: 'Vintegris',
  },
  {
    id: 5,
    name: 'ViaFirma',
  },
  {
    id: 6,
    name: 'FirmaCloud',
  },
  {
    id: 7,
    name: 'SealSign',
  },
  {
    id: 9,
    name: 'Bicert',
  },
  {
    id: 8,
    name: 'Almacén de Windows',
  },
]

export {
  TIPOS_HSM
}

